import React from 'react';
import { useEffect } from 'react';
import CautionIcon from '../../../../_styles/images/Caution.svg';
import Close from '../../../../_styles/images/close-icon-green.svg';
import analyticsService from '../../../../shared/analytics/analytics-service';
import Callable from '../../../../shared/Callable';

export default function ConfirmationPopup(props) {

  useEffect(() => {
    if (props.cardType && props.cardType == 'backup') {
      analyticsService.analyticsProcessEvent({
        "event": "modal_view_generic",
        "context": {
          "event_action": props.heading.toLowerCase() + " modal"
        }
      });
    } else if (props.cardType && props.cardType == 'default') {
      analyticsService.analyticsProcessEvent({
        "event": "modal_view_generic",
        "context": {
          "event_action": props.heading.toLowerCase() + " modal"
        }
      });
    }


    setTimeout(() => {
      const acceptButton = document.querySelector('.confirmation-delete-button');
      acceptButton.focus();
    }, 100)
  }, [])

  const keyDownHandler = (e) => {
    if (e.keyCode === 9) {
      e.preventDefault();
      const firstFocusElement = document.querySelector('.confirmation-cancel-button');
      firstFocusElement.focus();
    }
  }

  const keyDownBackTabHandler = (e) => {
    if (e.shiftKey && e.keyCode == 9) {
      e.preventDefault();
      const lastFocusElement = document.querySelector('.confirmation-delete-button');
      lastFocusElement.focus();
    }
  }

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        const changesPopup = document.getElementById('delete-confirmation-container');
        if (changesPopup) {
          props.close();
        }
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])

  return (
    <div className={`card-operations-container ${ props.showAssistance ? 'retail-confirm-container' : ''}`} ref={props.reference} role='dialog' aria-describedby='heading' aria-modal='true'>
      {
        props.showAssistance &&
        <div className='retail-confirm-header'>
          <img className='close' src={Close} onClick={props.close} role='button' alt='close icon' />
        </div>
      }
      <div className={`delete-confirmation-container ${props.showAssistance ? 'show-assistance' : ''}`} id='delete-confirmation-container'>
        <div className='caution-icon'>
          <img src={CautionIcon} alt='warning image'></img>
        </div>
        <div className={`heading ${props.showAssistance ? 'retail-confirm-heading' : ''}`} id='heading'>{props.heading}</div>
        <div className={`foot-notes ${props.showAssistance ? 'add-padding' : ''}`}>{props.text}</div>
        {
          props.showAssistance &&
          <div className='assistance'>
            <div className='help'>
              Need help?
            </div>
            <div className="pre-text">
              If you need assistance please contact
            </div>
            <Callable className="greentext" phone="800 VAN 4 WORK" />
          </div>
        }
        <div className={`buttons ${props.showAssistance ? 'retail-confirm-buttons' : ''}`}>
          <button className={`confirmation-cancel-button ${props.showAssistance ? 'retail-confirm-cancel' : ''}`} onClick={props.close} onKeyDown={keyDownBackTabHandler}>{props.cancelButtonText || 'cancel'}</button>
          <button className={`confirmation-delete-button ${props.showAssistance ? 'retail-confirm-delete' : ''}`} disabled={false} onClick={props.confirm} onKeyDown={keyDownHandler}>{props.confirmButtonText}</button>
        </div>
      </div>
    </div>
  );
}
